import { Environment } from './environment';

const environmentNames = {
    [Environment.Staging]: 'Development',
    [Environment.Production]: 'Production',
    [Environment.Testing]: 'Testing',
};

export default environmentNames;